export interface SelfProfileInput {
  first_name?: string;
  last_name?: string;
  email?: string;
  password?: string;
  confirm_password?: string;
  reset_tfa?: boolean;
}

export interface SelfProfileValidationResult {
  ok: boolean;
  error?: string;
  payload?: {
    first_name: string;
    last_name: string;
    email: string;
    password?: string;
    reset_tfa?: boolean;
  };
}

export function validateProfileForm(input: SelfProfileInput): SelfProfileValidationResult {
  const firstName = (input.first_name ?? "").trim();
  const lastName = (input.last_name ?? "").trim();
  const email = (input.email ?? "").trim();
  const password = input.password ?? "";
  const confirmPassword = input.confirm_password ?? "";

  if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return { ok: false, error: "A valid email address is required." };
  }

  if (password.length > 0) {
    if (password.length < 8) {
      return { ok: false, error: "Password must be at least 8 characters." };
    }
    if (password !== confirmPassword) {
      return { ok: false, error: "Passwords do not match." };
    }
  } else if (confirmPassword.length > 0) {
    return { ok: false, error: "Passwords do not match." };
  }

  const payload: SelfProfileValidationResult["payload"] = {
    first_name: firstName,
    last_name: lastName,
    email,
  };

  if (password.length > 0) {
    payload.password = password;
  }

  if (input.reset_tfa) {
    payload.reset_tfa = true;
  }

  return { ok: true, payload };
}

export function formatDisplayName(firstName?: string | null, lastName?: string | null, email?: string | null): string {
  const full = [firstName?.trim(), lastName?.trim()].filter(Boolean).join(" ");
  return full || (email ?? "").trim() || "Account";
}
